export default "__VITE_ASSET__Cws31fCg__"